import { IconType } from 'react-icons';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

const Container = styled.div<{ $isSelected: boolean }>`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-radius: 8px;
  gap: 12px;
  color: ${(props) => (props.$isSelected ? props.theme.global.whiteTextColor : props.theme.global.textColor)};
  background-color: ${(props) => (props.$isSelected ? props.theme.global.mainColor : 'transparent')};

  &:hover {
    ${(props) => {
      if (!props.$isSelected) {
        return {
          backgroundColor: props.theme.global.hoverBgColor,
        };
      }
    }}
  }
`;

interface MenuProps {
  to: string;
  name: string;
  isSelected: boolean;
  Icon: IconType;
}

const Menu = ({ to, name, isSelected, Icon }: MenuProps) => {
  return (
    <Link to={to}>
      <Container $isSelected={isSelected}>
        <Icon />
        <span>{name}</span>
      </Container>
    </Link>
  );
};

export default Menu;
